import { Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { CustomComponent } from './components/pages/custom/custom.component';
import { Error404Component } from './components/pages/error-404/error-404.component';
import { GarageComponent } from './components/pages/garage/garage.component';
import { ProjectViewerComponent } from './components/pages/project-viewer/project-viewer.component';
import { ProjectEmbedComponent } from './components/pages/project-embed/project-embed.component';
import { EditLayoutComponent } from './core/layout/layouts/edit-layout/edit-layout.component';
import { EmbedLayoutComponent } from './core/layout/layouts/embed-layout/embed-layout.component';
import { DemoComponent } from './components/pages/demo/demo.component';
import { MyEmbedListComponent } from './components/pages/my-embed-list/my-embed-list.component';
import { authGuard, authNoGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'my-embed',
    canActivate: [authGuard],
    component: MyEmbedListComponent,
  },
  {
    path: 'garage/:user/:templateSlug',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: GarageComponent,
      },
    ],
  },
  {
    path: 'edit/:uuid',
    component: EditLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: EmbedLayoutComponent,
        children: [
          {
            path: '',
            component: ProjectEmbedComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'viewer/:templateId',
    canActivate: [authNoGuard],
    component: ProjectViewerComponent,
  },
  {
    path: 'embed/:uuid',
    component: EmbedLayoutComponent,
    children: [
      {
        path: '',
        component: ProjectEmbedComponent,
      },
    ],
  },
  {
    path: 'workspace',
    canActivate: [authNoGuard],

    component: LayoutComponent,
    children: [
      {
        path: ':user/:templateSlug',
        component: CustomComponent,
      },
    ],
  },
  {
    path: 'demo/karbel',
    canActivate: [authNoGuard],
    data: {
      demoUuid: '3e557734-031a-410d-8c0a-93405a0633d6',
    },
    component: DemoComponent,
  },
  {
    path: 'demo/takd',
    data: {
      demoUuid: 'a5557734-9c10-82ca-8c0a-13405a0653d6',
    },
    component: DemoComponent,
  },
  {
    path: '**',
    component: Error404Component,
  },
];
